import React from 'react'
import { Chart } from 'react-google-charts'
import { generateAddress, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { ChartsWidget1 } from '../../../../../../_metronic/partials/widgets'
import { ChartsWidget9C1 } from '../../../../../../_metronic/partials/widgets/charts/ChartsWidget9C1'
import { useAuth } from '../../../../auth'


interface MonthlyReportProps {
  companyName?: string
  companyAddress?: string
  month?: string
  inventory?: any
  analyticsMonth?: any
  graphData?: any
  supplierData?: any
}

export const data = [
  ['From', 'To', 'Weight'],
  ['A', 'X', 5],
  ['A', 'Y', 7],
  ['A', 'Z', 6],
  ['B', 'X', 2],
  ['B', 'Y', 9],
  ['B', 'Z', 4],
]
const options = {}

const inventoryHeader = [
  { label: 'Category', name: 'categoryName' },
  { label: 'Item', name: 'itemName' },
  { label: 'Open', name: 'openInventory' },
  { label: 'Inward', name: 'received' },
  { label: 'Process', name: 'processed' },
  { label: 'Outward', name: 'supplied' },
  { label: 'Close', name: 'closingInventory' },
]
// const newHeader = [
//   { label: 'Process', name: 'name' },
//   { label: 'Output', name: 'quantity' },
//   { label: 'Wastage', name: 'newQuantity' },
//   { label: 'Yield (%)', name: 'yield' },
// ]

const newHeader = [
  // { label: 'SL', name: 'name' },
  { label: 'Customer name', name: 'quantity' },
  { label: 'Quantity supplied', name: 'newQuantity' },
  { label: 'Sale value', name: 'yield' },
]

/* SL Supplier name Quantity received. Payment made */

const supplierWise = [
  // { label: 'SL', name: 'categoryName' },
  { label: 'Supplier name', name: 'supplierName' },
  { label: 'Quantity received', name: 'suppliedQuantity' },
  { label: 'Amount paid', name: 'paidAmount' },
]

const MonthlyReport: React.FC<MonthlyReportProps> = ({
  companyName = 'Company name',
  companyAddress = 'Company Address',
  month = 'October 2024',
  inventory = {},
  analyticsMonth = {},
  graphData = {},
  supplierData = {},
}) => {

  console.log("incoming data is..........", inventory)

  let pieChartData1 = [['Process', 'Amount']]
  let pieChartData2 = [['Process', 'Amount']]
  let pieChartData3 = [['Process', 'Amount']]
  analyticsMonth?.processDetails?.map((x) => {
    return pieChartData1.push([x.name, x.quantity])
  })
  analyticsMonth?.suppliedDetails?.map((x) => {
    return pieChartData2.push([x.pickupPointName, x.quantitySupplied])
  })
  pieChartData3 = [
    ...pieChartData3,
    ...(analyticsMonth?.remarkQuantity?.map((item) => Object.entries(item)[0]) || []),
  ]

  const processData = analyticsMonth?.processDetails || []
  const wastagesDatas = analyticsMonth?.wastageDetails || []

  // Generate days array for x-axis
  const days = Array.from({ length: 30 }, (_, i) => `Day ${i + 1}`)
  // Data for trend charts
  const collectedData =
    (graphData?.collectionDetails && Object.values(graphData.collectionDetails)) || []
  const wastageData = (graphData?.wastageDetails && Object.values(graphData.wastageDetails)) || []
  const processingData =
    (graphData?.productionDetails && Object.values(graphData.productionDetails)) || []
  const supplyData = (graphData?.returnDetails && Object.values(graphData.returnDetails)) || []
  const receivedData =
    (graphData?.receivedDetails && Object.values(graphData.receivedDetails)) || []

  // Prepare data for trend charts
  const trendData: any = [['Day', 'Collected' /*  'Received' */]]
  const processingChartData: any = [['Day', 'Processing']]
  const supplyChartData: any = [['Day', 'Supply']]
  const wastageChartDataData: any = [['Day', 'Supply']]
  const receivedChartDataData: any = [['Day', 'Supply']]

  days.forEach((day, index) => {
    trendData.push([day, collectedData[index] ?? 0])
    processingChartData.push([day, processingData[index] ?? 0])
    supplyChartData.push([day, supplyData[index] ?? 0])
    wastageChartDataData.push([day, wastageData[index] ?? 0])
    receivedChartDataData.push([day, receivedData[index] ?? 0])
  })

  const trendDataLabel = trendData.slice(1).map((item) => item[0])
  const trendDataValues = trendData.slice(1).map((item) => item[1])

  const processingDataLabel = processingChartData.slice(1).map((item) => item[0])
  const processingDataValues = processingChartData.slice(1).map((item) => item[1])

  const supplyDataLabel = supplyChartData.slice(1).map((item) => item[0])
  const supplyDataValues = supplyChartData.slice(1).map((item) => item[1])

  const wastageDataLabel = wastageChartDataData.slice(1).map((item) => item[0])
  const wastageDataValues = wastageChartDataData.slice(1).map((item) => item[1])

  const { currentUser, auth, isFacilityManager, isSupplyChainManager }: any = useAuth()
  const image = isSupplyChainManager
    ? auth?.data?.profileImage || ''
    : isFacilityManager
      ? toAbsoluteUrl('/media/avatars/facMan.jpeg')
      : isSupplyChainManager
        ? currentUser?.franchiseKycDoc?.filter((x) => x?.docType === 'SEC_DTI')?.[0]?.docUrl
        : currentUser?.kycDocument?.filter((x) => x?.docType === 'SEC_DTI')?.[0]?.docUrl ||
        currentUser?.kycDocument?.filter((x) => x?.docType === 'CLIENT_LOGO')?.[0]?.docUrl

  return (
    <div
      // style="2px solid black"
      className=' mx-auto p-5 font-sans'
      style={{
        width: '930px',
        // border: '2px solid lightgray',
        margin: '0 auto',
        padding: '10px',
        fontFamily: 'Arial',
        border: "3px solid black",
        borderRadius: "10px"
      }}
    >
      <div className='border-b-2 border-gray-300 pb-2'>
        <table style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td style={{ width: '90%', textAlign: 'left' }}>
                <h1
                  className='text-2xl text-blue-900 italic m-0'
                // style={{ borderBottom: '2px solid gray' }}
                >
                  <em style={{ color: 'rgb(28, 67, 121)' }}> Supply chain report</em>
                </h1>
              </td>
              <td style={{ width: '30%', textAlign: 'right' }}>

                {/* <img
                  src={toAbsoluteUrl('/media/imgs/in.png')}
                  alt='Company Logo'
                  style={{ maxHeight: '50px' }}
                /> */}


                <img
                  src={image || toAbsoluteUrl('/media/avatars/profile.jpeg')}
                  alt=''
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '8px',
                    objectFit: 'cover'
                  }}
                />


              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className='my-4 w-full'>
        <table
          className='w-full border-collapse'
          style={{
            width: '750px',
          }}
        >
          <tbody>
            <tr>
              <td className='py-2 w-3/4'>
                <div>
                  {/* <strong>Name:</strong> {analyticsMonth?.pickupPointName || companyName} */}
                  <strong>Name:</strong> {inventory?.franchiseName || companyName}
                </div>
                <div>
                  <strong>Address:</strong>{' '}
                  {generateAddress(analyticsMonth?.pickupPointAddress) || companyAddress}
                </div>
                <div>
                  <strong>Period:</strong> {month}
                </div>
              </td>
              {/*  <td className='py-2 text-right'>
                <img
                  src={toAbsoluteUrl('/media/imgs/companyLogo.jpg')}
                  alt='Company Logo'
                  className='h-14 w-auto'
                />
              </td> */}
            </tr>
          </tbody>
        </table>
      </div>

      <div className='my-4'>
        <h4 className='text-lg font-bold'>Executive summary</h4>
        <p style={{ margin: '0', padding: '0' }}>
          This section summarizes the key findings and insights from the monthly report.
        </p>
      </div>
      {/* <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '10px',
          padding: '4px',
        }}
      >
        {[
          { label: 'Collected', value: '2,500 kg', name: 'collected' },
          { label: 'Processed', value: '2,400 kg', name: 'processed' },
          { label: 'Recycled', value: '1,800 kg', name: 'diversionProductionQuantity' },
          { label: 'Supplied', value: '2,300 kg', name: 'supplied' },
          { label: 'Stock transfer', value: '1,500 kg', name: 'received' },
          { label: 'Closing stock', value: '1,000', name: 'stock' },
        ].map((item, index) => (
          <div
            key={index}
            style={{
              border: '1px solid #d1d5db',
              borderRadius: '6px', // Slightly smaller border radius
              padding: '10px', // Reduced padding
              textAlign: 'left',
              boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)', // Reduced shadow
              fontSize: '0.9rem', // Smaller font size
              margin: '2px',
            }}
          >
            <p style={{ fontWeight: 'bold', margin: '0' }}>{item.label}</p>
            <p style={{ margin: '0' }}>
              {analyticsMonth[item.name]?.toFixed(2)} {item.label !== 'Plastic Credits' && ' kg'}
            </p>
          </div>
        ))}
      </div> */}



      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '10px',
          padding: '4px',
        }}
      >
        <div
          style={{
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            padding: '10px',
            textAlign: 'left',
            boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)',
            fontSize: '0.9rem',
            margin: '2px',
            background: "white"
          }}
        >
          <p style={{ fontWeight: 'bold', margin: '0' }}>Collected</p>
          <p style={{ margin: '0' }}>{Number(inventory?.data?.collected || 0).toFixed(2)} kg</p>
        </div>

        <div
          style={{
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            padding: '10px',
            textAlign: 'left',
            boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)',
            fontSize: '0.9rem',
            margin: '2px',
            background: "white"
          }}
        >
          <p style={{ fontWeight: 'bold', margin: '0' }}>Processed</p>
          <p style={{ margin: '0' }}>{Number(inventory?.data?.processed || 0).toFixed(2)} kg</p>
        </div>

        <div
          style={{
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            padding: '10px',
            textAlign: 'left',
            boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)',
            fontSize: '0.9rem',
            margin: '2px',
            background: "white"
          }}
        >
          <p style={{ fontWeight: 'bold', margin: '0' }}>Recycled</p>
          <p style={{ margin: '0' }}>
            {Number(inventory?.data?.diversionProductionQuantity || 0).toFixed(2)} kg
          </p>
        </div>

        <div
          style={{
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            padding: '10px',
            textAlign: 'left',
            boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)',
            fontSize: '0.9rem',
            margin: '2px',
            background: "white"
          }}
        >
          {/* <p style={{ fontWeight: 'bold', margin: '0' }}>Supplied</p> */}
          <p style={{ fontWeight: 'bold', margin: '0' }}>Stock transfer</p>
          {/* <p style={{ margin: '0' }}>{Number(inventory?.supplied || 0).toFixed(2)} kg</p> */}
          <p style={{ margin: '0' }}>{Number(inventory?.data?.stockTransfer || 0).toFixed(2)} kg</p>
        </div>

        <div
          style={{
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            padding: '10px',
            textAlign: 'left',
            boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)',
            fontSize: '0.9rem',
            margin: '2px',
            background: "white"
          }}
        >
          <p style={{ fontWeight: 'bold', margin: '0' }}>Sales</p>
          <p style={{ margin: '0' }}>{Number(inventory?.data?.sales || 0).toFixed(2)} kg</p>
        </div>

        <div
          style={{
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            padding: '10px',
            textAlign: 'left',
            boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)',
            fontSize: '0.9rem',
            margin: '2px',
            background: "white"
          }}
        >
          <p style={{ fontWeight: 'bold', margin: '0' }}>Process loss</p>
          <p style={{ margin: '0' }}>{Number(inventory?.data?.wastage || 0).toFixed(2)} kg</p>
        </div>
      </div>





      {/* <table style={{ width: '95%', borderCollapse: 'collapse' }}>
        <tbody>
          <tr>
            <td
              style={{
                width: '50%',
                verticalAlign: 'top',
                padding: '10px',
                borderCollapse: 'collapse',
              }}
            >
              <h4>Production by process</h4>
              <div
                className='card p-5 mb-5'
                style={
                  {
                    // height: '200px',
                  }
                }
              >
                <Chart
                  width='100%'
                  height='300px'
                  chartType='PieChart'
                  data={pieChartData1}
                  options={{
                    legend: { position: 'left' },
                    pieSliceText: 'percentage',
                  }}
                />
              </div>
            </td>
            <td style={{ width: '50%', verticalAlign: 'top', padding: '10px' }}>
              <h4>Customer wise dispatch</h4>
              <div className='card p-5 mb-5'>
                <Chart
                  width='100%'
                  height='300px'
                  chartType='PieChart'
                  data={pieChartData2}
                  options={{
                    legend: { position: 'left' },
                    pieSliceText: 'percentage',
                  }}
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table> */}





      <table style={{ width: '95%', borderCollapse: 'collapse' }}>
        <tbody>
          <tr>
            <td style={{ width: '50%', verticalAlign: 'top', padding: '10px' }} className='mb-10'>
              {/* <h4>Financial summary</h4> */}
              <div
                className='card p-5 mb-5'
                style={{
                  height: '235px',
                }}
              >
                <h4>Financial summary</h4>
                <div className='mb-4 mt-5'>
                  <strong>Revenue:</strong> {inventory?.data?.externalSale || 0}
                </div>
                <div className='mb-4'>
                  <strong>Raw material cost:</strong>{' '}
                  {inventory?.data?.totalPurchaseCost?.toFixed(2) || ''}
                </div>
                <div className='mb-4'>
                  <strong>Processing cost:</strong>{' '}
                  {inventory?.data?.totalProcessingCost?.toFixed(2) || ''}
                </div>
                <div className='mb-4'>
                  <strong>Operating margin:</strong> {inventory?.data?.grossMargin?.toFixed(2)}
                </div>
              </div>
            </td>
            <td
              style={{
                width: '50%',
                verticalAlign: 'top',
                padding: '10px',
              }}
            >
              {/* <h4>Feedstock certification</h4> */}
              <div
                className='card p-5 mb-5'
                style={
                  {
                    // height: '200px',
                  }
                }
              >
                {/* <Chart
                  width='100%'
                  height='200px'
                  chartType='PieChart'
                  data={pieChartData3}
                  options={{
                    legend: { position: 'left' },
                    pieSliceText: 'percentage',
                  }}
                /> */}
                <h4>Feedstock certification</h4>
                <ChartsWidget9C1
                  className="mb-5"
                  label=""
                  data={
                    inventory?.data?.characteristicQuantityPairs?.map(item => {
                      const key = Object.keys(item)[0]
                      return {
                        name: key,
                        value: item[key]
                      }
                    }) || []
                  }
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>







      <div className='card p-4  mb-3'>
        <h4 className='text-lg font-bold my-6'>Production management</h4>
        <table className='table align-middle gs-0 gy-4'>
          <thead>
            <tr className='fw-bold bg-light'>
              <th style={{ width: '50px' }}>SL</th>
              <th style={{ width: '50px' }}>Process name</th>
              <th style={{ width: '50px' }}>Production</th>
              <th style={{ width: '50px' }}>Production Loss</th>
              <th style={{ width: '50px' }}>Yield %</th>
            </tr>
          </thead>
          <tbody>
            {/* {inventory?.processDetails?.map((supplier, index) => (
              <tr key={supplier?.supplierId || index}>
                <td>{index + 1}</td>
                <td>{supplier?.name?.trim() || 'N/A'}</td>
                <td>{Number(supplier?.quantity).toFixed(2)}</td>
                <td>
                  {(() => {
                    const wastage = inventory?.wastageDetails?.[index]; // Use the same index
                    return wastage ? Number(wastage.quantity).toFixed(2) : '--';
                  })()}
                </td>
                <td>{(Number(supplier?.yield) * 100).toFixed(2)}</td>
              </tr>
            ))} */}
            {inventory?.data?.processDetails?.map((supplier, index) => (
              <tr key={supplier?.supplierId || index}>
                <td>{index + 1}</td>
                <td>{supplier?.name?.trim() || 'N/A'}</td>
                <td>{Number(supplier?.quantity).toFixed(2)}</td>
                <td>
                  {(() => {
                    const wastage = inventory?.data?.wastageDetails?.[index];
                    return wastage ? Number(wastage.quantity).toFixed(2) : '--';
                  })()}
                </td>
                <td>{(Number(supplier?.yield) * 100).toFixed(2)}</td>
              </tr>
            ))}
            <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
              <td>-</td>
              <td>Total</td>
              <td>{inventory?.data?.processDetails?.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0).toFixed(2)}</td>
              <td>{inventory?.data?.wastageDetails?.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0).toFixed(2)}</td>
              <td>-</td>
            </tr>
          </tbody>
        </table>
      </div>





      <div className='card p-4  mb-3'>
        <h4 className='text-lg font-bold my-6'>Supplier management</h4>
        <table className='table align-middle gs-0 gy-4'>
          <thead>
            <tr className='fw-bold bg-light'>
              <th style={{ width: '50px' }}>SL</th>
              {supplierWise.map((x, ind) => (
                <th className='min-w-125px' key={ind + 1 + ''}>
                  {x.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {/* {inventory?.supplierTable?.map((supplier, index) => (
              <tr key={supplier?.supplierId || index}>
                <td>{index + 1}</td>
                <td>{supplier?.supplierName?.trim() || 'N/A'}</td>
                <td>{Number(supplier?.suppliedQuantity).toFixed(2)}</td>
                <td>{Number(supplier?.paidAmount).toFixed(2)}</td>
              </tr>
            ))} */}
            {inventory?.data?.supplierTable?.map((supplier, index) => (
              <tr key={supplier?.supplierId || index}>
                <td>{index + 1}</td>
                <td>{supplier?.supplierName?.trim() || 'N/A'}</td>
                <td>{Number(supplier?.suppliedQuantity).toFixed(2)}</td>
                <td>{Number(supplier?.paidAmount).toFixed(2)}</td>
              </tr>
            ))}
            <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
              <td>-</td>
              <td>Total</td>
              <td>{inventory?.data?.supplierTable?.reduce((sum, item) => sum + (Number(item.suppliedQuantity) || 0), 0).toFixed(2)}</td>
              <td>{inventory?.data?.supplierTable?.reduce((sum, item) => sum + (Number(item.paidAmount) || 0), 0).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* <div className='card p-4'>
        <h4 className='text-lg font-bold my-6'>Inventory table</h4>
        <table className='table align-middle gs-0 gy-4'>
          <thead>
            <tr className='fw-bold text-dark bg-light'>
              {inventoryHeader.map((x, ind) => (
                <th className='min-w-125px' key={ind + 1 + ''}>
                  {x.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
         
          </tbody>
        </table>
      </div> */}



      <div className='card p-4'>
        <h4 className='text-lg font-bold my-6'>Inventory table</h4>
        <table className='table align-middle gs-0 gy-4'>
          <thead>
            <tr className='fw-bold  bg-light'>
              <th className='min-w-125px'>Category</th>
              <th className='min-w-125px'>Item</th>
              <th className='min-w-125px'>Open</th>
              <th className='min-w-125px'>Inward</th>
              <th className='min-w-125px'>Process</th>
              <th className='min-w-125px'>Outward</th>
              <th className='min-w-125px'>Close</th>
            </tr>
          </thead>
          <tbody>
            {inventory?.data?.inventoryTable?.map((row, index) => (
              <tr key={row.itemId || index}>
                <td>{row.categoryName}</td>
                <td>{row.itemName}</td>
                <td>{Number(row.openInventory).toFixed(2)}</td>
                <td>{Number(row.received).toFixed(2)}</td>
                <td>{Number(row.processed).toFixed(2)}</td>
                <td>{Number(row.supplied).toFixed(2)}</td>
                <td>{Number(row.closingInventory).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>





      <div className='card mt-4 p-4'>
        <h4 className='text-lg font-bold my-6'>Customer management</h4>
        <table className='table align-middle gs-0 gy-4'>
          <thead>
            <tr className='fw-bold  bg-light'>
              <th style={{ width: '50px' }}>SL</th>
              {newHeader.map((x, ind) => (
                <th className='min-w-125px' key={ind + 1 + ''}>
                  {x.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {/* {inventory?.aggregatorTable?.map((aggregator, index) => (
              <tr key={aggregator.aggregatorId || index}>
                <td>{index + 1}</td>
                <td>{aggregator.aggregatorName.trim()}</td>
                <td>{Number(aggregator.suppliedQuantity).toFixed(2)}</td>
                <td>{Number(aggregator.paidAmount).toFixed(2)}</td>
              </tr>
            ))} */}
            {inventory?.data?.aggregatorTable?.map((aggregator, index) => (
              <tr key={aggregator.aggregatorId || index}>
                <td>{index + 1}</td>
                <td>{aggregator.aggregatorName.trim()}</td>
                <td>{Number(aggregator.suppliedQuantity).toFixed(2)}</td>
                <td>{Number(aggregator.paidAmount).toFixed(2)}</td>
              </tr>
            ))}
            <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
              <td>-</td>
              <td>Total</td>
              <td>{inventory?.data?.aggregatorTable?.reduce((sum, item) => sum + (Number(item.suppliedQuantity) || 0), 0).toFixed(2)}</td>
              <td>{inventory?.data?.aggregatorTable?.reduce((sum, item) => sum + (Number(item.paidAmount) || 0), 0).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className=' my-4'>
        <h4 className='text-lg font-bold mb-4'>Daily trends</h4>
        <ChartsWidget1
          // label={inventory.collectiontTrend || []}
          label={Object.keys(inventory?.data?.collectionTrend || {}) || []}
          data={Object.values(inventory?.data?.collectionTrend || {}) || []}
          // data={inventory.collectiontTrend || []}
          title='Day wise material incoming (kg)'
          className='card-xl-stretch mb-xl-8'
          subTitle='All values in kg'
        />
        <div className='print-section no-break my-4'>
          <ChartsWidget1
            label={Object.keys(inventory?.data?.productionTrend || {}) || []}
            data={Object.values(inventory?.data?.productionTrend || {}) || []}
            title='Day wise Processing (kg)'
            className='card-xl-stretch mb-xl-8'
            subTitle='All values in kg'
          />
        </div>

        <div className='print-section no-break my-4'>
          <ChartsWidget1
            label={Object.keys(inventory?.data?.recyclingTrend || {}) || []}
            data={Object.values(inventory?.data?.recyclingTrend || {}) || []}
            title='Day wise recycling (kg)'
            className='card-xl-stretch mb-xl-8'
            subTitle='All values in kg'
          />
        </div>

        <div className='print-section no-break my-4'>
          <ChartsWidget1
            label={Object.keys(inventory?.data?.stockTransferTrend || {}) || []}
            data={Object.values(inventory?.data?.stockTransferTrend || {}) || []}
            title='Day wise stock transfer (kg)'
            className='card-xl-stretch mb-xl-8'
            subTitle='All values in kg'
          />
        </div>

        <div className='print-section no-break my-4'>
          <ChartsWidget1
            label={Object.keys(inventory?.data?.salesTrend || {}) || []}
            data={Object.values(inventory?.data?.salesTrend || {}) || []}
            title='Day wise sales (kg)'
            className='card-xl-stretch mb-xl-8'
            subTitle='All values in kg'
          />
        </div>
      </div>

      <div className='print-section no-break my-4'>
        <h4 className='text-lg font-bold'>Recommendations</h4>
        <ul className='list-disc pl-5'>
          <li>Consider increasing the collection frequency for high-demand items.</li>
          <li>Explore new suppliers for better pricing on collected materials.</li>
          <li>Enhance marketing strategies to raise awareness about recycling.</li>
        </ul>
      </div>

      <div className='print-section no-break my-4'>
        <h4 className='text-lg font-bold'>Glossary</h4>
        <p>
          <strong>Open inventory:</strong> Inventory available at the start of the month.
        </p>
        <p>
          <strong>Closing inventory:</strong> Inventory remaining at the end of the month.
        </p>
      </div>

      <footer className=' print-section text-center text-sm text-gray-600 border-t-2 border-gray-300 pt-4 mt-8'>
        {/* Add footer content here */}
      </footer>

      <style>
        {`




                @media print {
                    /* General print styles */
                    .print-container {
                        width: 100% !important;
                        max-width: none !important;
                        margin: 0 !important;
                        padding: 20px !important;
                    }

                    /* Prevent unwanted page breaks */
                    .no-break {
                        page-break-inside: avoid !important;
                    }

                    /* Ensure charts fit on pages */
                    .charts-container {
                        margin: 20px 0 !important;
                        page-break-before: auto !important;
                    }

                    /* Adjust chart sizes for print */
                    .print-section Chart {
                        max-height: 400px !important;
                        margin-bottom: 20px !important;
                    }

                    /* Ensure proper page breaks between sections */
                    .print-section {
                        margin: 20px 0 !important;
                        page-break-inside: avoid !important;
                    }

                    /* Remove unnecessary backgrounds and borders for print */
                    @page {
                        margin: 0.5in;
                    }

                    /* Ensure text is readable when printed */
                    body {
                        font-size: 12pt !important;
                        line-height: 1.3 !important;
                    }

                    /* Ensure tables look good in print */
                    table {
                        page-break-inside: avoid !important;
                        border-collapse: collapse !important;
                    }

                    /* Ensure charts don't get cut off */
                    svg {
                        max-height: 400px !important;
                    }
                }
                    @media print {
    .chart-container {
        width: 100% !important; // Ensure the chart takes full width
    }
    svg {
        width: 100% !important; // Ensure SVGs are properly sized
        height: auto !important;
    }
}

                `}
      </style>
    </div>
  )
}

export default MonthlyReport
